module.exports = __webpack_public_path__ + "img/nav-design-diamondrings.18e6835.jpg";